<template>
  <div v-loading="loading" class="alarmClass">
    <div>
     
      <el-divider content-position="left"></el-divider>
      <el-form :model="searchForm" ref="searchFormRef" label-width="100px" label-suffix=":">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="时间">
              <div style="display: flex;">
                <el-date-picker
                  style="width:42%;"
                  v-model="searchForm.detectionTimeStart"
                  type="date"
                  value-format="yyyy-MM-dd"
                  range-separator="到"
                  placeholder="开始日期"
                >
                </el-date-picker>
                到
                <el-date-picker
                  style="width:42%;"
                  v-model="searchForm.detectionTimeEnd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  range-separator="到"
                  placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <div style="float: right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="1" label="心率">
          <avue-crud
            :option="heartOption"
            :table-loading="loading"
            :data="heartData"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud>
        </el-tab-pane>
        <el-tab-pane name="2" label="血氧饱和度" lazy>
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="bloodOxygenData"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud
        ></el-tab-pane>
        <el-tab-pane name="3" label="血压" lazy>
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="bloodPressureData"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud>
        </el-tab-pane>
        <el-tab-pane name="4" label="血糖" lazy>
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="bloodSugarData"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud>
        </el-tab-pane>
        <el-tab-pane name="5" lazy label="血脂"
          ><avue-crud
            :option="option"
            :table-loading="loading"
            :data="bloodFatData"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud
        ></el-tab-pane>
        <el-tab-pane name="6" lazy label="体温"
          ><avue-crud
            :option="option"
            :table-loading="loading"
            :data="temperatureData"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud
        ></el-tab-pane>
        <el-tab-pane name="7" lazy label="睡眠数据"
          ><avue-crud
            :option="option"
            :table-loading="loading"
            :data="sleepData"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
          >
          </avue-crud
        ></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { getHealthDataPage } from '@/api/nursingHome/healthData.js';
export default {
  components: {},

  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},

    model: {
      default: 'add',
    },
  },
  data() {
    return {
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      searchForm: {
        detectionTimeStart: '',
        detectionTimeEnd: '',
        dataType: '1',
        wristbandId: '',
        nursinghomeId: '',
      },
      activeName:'1',
      heartData: [],
      bloodOxygenData: [],
      bloodSugarData: [],
      bloodFatData: [],
      temperatureData: [],
      sleepData: [],
      motionData: [],
      bloodPressureData: [],
      form: {
        name: '',
        sex: '',
        deviceTypeName:'',
        age:''
      },
      heartOption: {
        selection: false,
        select: false,
        index: true,
        indexLabel: '#',
        page: true,
        height: '500',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '数据分类',
            prop: 'dataTypeValue',
          },

          {
            label: '指标名称',
            prop: 'targetName',
          },

          {
            label: '数值',
            prop: 'targetValue',
          },
          {
            label: '测量时间',
            prop: 'detectionTime',
          },
        ],
      },
      option: {
        selection: false,
        select: false,
        index: true,
        indexLabel: '#',
        page: true,
        height: '500',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '数据分类',
            prop: 'dataTypeValue',
          },

          {
            label: '指标名称',
            prop: 'targetName',
          },

          {
            label: '指标数值',
            prop: 'targetValue',
          },
          {
            label: '测量时间',
            prop: 'detectionTime',
          },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    searchRecord(){
      this.page.current=1
      this.onLoad()
    },
    searchClear(){

      this.searchForm.detectionTimeEnd=""
this.searchForm.detectionTimeStart=""
    },
    handleClick() {
      this.searchForm.dataType = this.activeName;
      this.page.currentPage =1
      this.onLoad()
    },
    

     initData() {
      console.log(this.row,"this.row")
     this.searchForm.nursinghomeId=this.row.nursinghomeId
     this.searchForm.elderlyId=this.row.id
    
     this.onLoad()
    },
    saveRecord() {},
    cancleRecord() {
      this.$emit('cancle');
    },
    onLoad() {
      
      getHealthDataPage(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize },
          this.searchForm
        )
      )
        .then(({ data }) => {
          if (this.searchForm.dataType == 1) {
            this.heartData = data.records;
          } else if (this.searchForm.dataType == 2) {
            this.bloodOxygenData = data.records;
          } else if (this.searchForm.dataType == 3) {
            this.bloodPressureData = data.records;
          } else if (this.searchForm.dataType == 4) {
            this.bloodSugarData = data.records;
          } else if (this.searchForm.dataType == 5) {
            this.bloodFatData = data.records;
          } else if (this.searchForm.dataType == 6) {
            this.temperatureData = data.records;
          } else if (this.searchForm.dataType == 7) {
            this.sleepData = data.records;
          }
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
